export const PATHWAY_TYPE_LINEAR = 'LINEAR';
export const PATHWAY_TYPE_FREE = 'FREE';
